import React, { useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Badge } from 'primereact/badge';
import { Toast } from 'primereact/toast';

const Memberships = () => {
  const toast = useRef(null);
  const [memberships] = useState([
    {
      id: 1,
      type: 'Annual Premium Membership',
      validTo: new Date('2024-12-31'),
      status: 'active',
      benefits: ['Event Discounts', 'Premium Support', 'Exclusive Content', 'Early Registration']
    },
    {
      id: 2,
      type: 'Regional Membership',
      validTo: new Date('2024-08-15'),
      status: 'active',
      benefits: ['Regional Events', 'Local Support', 'Newsletter Access']
    }
  ]);

  const [selectedMembership, setSelectedMembership] = useState(null);
  const [displayCard, setDisplayCard] = useState(false);

  const statusBodyTemplate = (rowData) => {
    const isActive = rowData.validTo > new Date();
    const severity = isActive ? 'success' : 'danger';
    const value = isActive ? 'ACTIVE' : 'EXPIRED';
    return <Badge value={value} severity={severity} />;
  };

  const validToBodyTemplate = (rowData) => {
    return rowData.validTo.toLocaleDateString('en-GB');
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <Button 
        icon="pi pi-id-card" 
        className="p-button-text" 
        tooltip="View Membership Card"
        onClick={() => {
          setSelectedMembership(rowData);
          setDisplayCard(true);
        }}
      />
    );
  };

  const MembershipCard = ({ membership }) => {
    if (!membership) return null;

    return (
      <div className="se-membership-card">
        <div className="se-membership-card-header">
          SPORT ENDURANCE MEMBERSHIP
        </div>
        <div className="se-membership-card-title">
          {membership.type}
        </div>
        <div className="se-membership-card-details">
          <div className="mb-2">
            <strong>Member:</strong> John Smith<br />
            <strong>Member ID:</strong> SE001234<br />
            <strong>Valid Until:</strong> {membership.validTo.toLocaleDateString('en-GB')}
          </div>
          <div className="text-xs opacity-80">
            This card grants access to all membership benefits and should be presented at events.
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="se-card">
        <div className="se-card-header">
          <h2>My Memberships</h2>
        </div>
        <div className="se-card-content">
          <DataTable value={memberships} responsiveLayout="scroll">
            <Column field="type" header="Membership Type" sortable />
            <Column field="validTo" header="Valid To" body={validToBodyTemplate} sortable />
            <Column field="status" header="Status" body={statusBodyTemplate} />
            <Column header="Card" body={actionBodyTemplate} />
          </DataTable>

          {/* Membership Benefits */}
          <div className="mt-4">
            <h3 className="se-text-primary mb-3">Membership Benefits</h3>
            <div className="grid">
              {memberships.map((membership, index) => (
                <div key={index} className="col-12 md:col-6">
                  <div className="p-3 border-1 border-200 border-round">
                    <h4 className="mt-0 mb-2">{membership.type}</h4>
                    <ul className="pl-3 mb-0">
                      {membership.benefits.map((benefit, benefitIndex) => (
                        <li key={benefitIndex} className="mb-1">{benefit}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Membership Card Dialog */}
      <Dialog
        header="Membership Card Preview"
        visible={displayCard}
        style={{ width: '400px' }}
        onHide={() => setDisplayCard(false)}
        footer={
          <div>
            <Button 
              label="Download" 
              icon="pi pi-download" 
              className="p-button-primary mr-2"
              onClick={() => {
                toast.current?.show({
                  severity: 'info',
                  summary: 'Download',
                  detail: 'Downloading membership card...',
                  life: 3000
                });
              }}
            />
            <Button 
              label="Close" 
              icon="pi pi-times" 
              className="p-button-secondary"
              onClick={() => setDisplayCard(false)}
            />
          </div>
        }
      >
        <MembershipCard membership={selectedMembership} />
      </Dialog>
    </div>
  );
};

export default Memberships;